/* eslint-disable */
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import moment from 'moment';
import clsx from 'clsx';
import Preview from './Preview';
import JobFilter from './JobFilter';
import { Divider } from '@mui/material';
import { timeMapping } from 'assert/OptionList';
import PaginationComp from 'components/Pagination';
import { BrandIconSpinner } from 'components';
import useWindowDimensions from 'components/Dimention';
import { useDispatch, useSelector } from 'react-redux';
import { getJobPostList } from 'redux/features/PostJobSlice';

import { PostBox } from 'pages/home/Home.style';
import { JobPostList, JobPostsStyle } from 'pages/jobs/JobPosts.style';

import { ReactComponent as SampleCompany } from 'assert/images/Jobs/sampleCompany.svg';
import { ReactComponent as NoDataFound } from 'assert/images/Common/noDataFound.svg';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { AuthContext } from 'router/AuthProvider';
import SwipeableEdgeDrawer from 'components/SwipeableDrawer';
import { swipeModalWidth } from 'utils/helper';
import { ProfileLoaderContainer } from 'pages/addprofile/Profile.style';
import LoginNotification from 'pages/auth/LoginNotification';

export const jobPageSize = 15;

export default function JobList() {
  const dispatch = useDispatch();
  const jobListRef = useRef(null);
  const { isLoggedIn } = useContext(AuthContext);

  const joblist = useSelector((state) => state?.PostJobReducer?.jobPostList);
  const Countrycode = useSelector((state) => state?.LoginReducer?.countryCode);
  const { getProfile } = useSelector((state) => state?.ProfileSlice);
  const userId = getProfile.userId;

  const { workTypeList, countryList } = useSelector(
    (state) => state?.DropdownReducer
  );

  const { width } = useWindowDimensions();
  const isSmallScreen = width >= swipeModalWidth;
  const jobLists = joblist?.rows;

  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [companyList, setCompanyList] = useState([]);
  const [jobDetailview, setJobDetailview] = useState({});
  const [initiateCtrList, setInitiateCtrList] = useState(true);
  const [isLoginNotificationOpen, setIsLoginNotificationOpen] = useState(false);

  const { t } = useTranslation();

  const handleGetList = useCallback(
    (country) => {
      let payload;
      if (isLoggedIn) {
        payload = {
          url: `jobPost/fetchAll/${userId}?location=${country}&page=0&size=${jobPageSize}&clientOffSet=${new Date().getTimezoneOffset()}`,
        };
      } else {
        payload = {
          url: 'jobPost/landing/pages',
        };
      }
      dispatch(getJobPostList(payload));
    },
    [userId, isLoggedIn, Countrycode?.country_code]
  );

  useEffect(() => {
    if (Countrycode?.country_code && initiateCtrList) {
      handleGetList(Countrycode?.country_code);
      setInitiateCtrList(false);
    }
  }, [Countrycode]);

  useEffect(() => {
    if (jobLists) {
      setCompanyList(jobLists);
      if (isSmallScreen) {
        setJobDetailview(jobLists?.[0]);
      }
      setLoading(false);
      if (jobListRef?.current) {
        setTimeout(() => {
          jobListRef.current.scrollTop = 0;
        }, 0);
      }
    }
  }, [jobLists]);

  useEffect(() => {
    if (isSmallScreen) {
      setJobDetailview(jobLists?.[0]);
    }
  }, [isSmallScreen]);

  return (
    <>
      <Helmet>
        <title>Jobs | WafyNet - Find Jobs and Career Opportunities</title>
        <meta
          name="description"
          content="Search and apply for the latest job openings on Wafynet. Find your dream career and connect with top employers worldwide."
        />
      </Helmet>
      <JobFilter page={page} hanldeResetPage={() => setPage(0)} />
      <JobPostsStyle>
        <PostBox>
          {loading && (
            <ProfileLoaderContainer>
              <BrandIconSpinner loading={loading} />
            </ProfileLoaderContainer>
          )}
          {!loading && jobLists?.length > 0 ? (
            <JobPostList className="listpages">
              <div className="job-list-container">
                <div ref={jobListRef} id="job-list">
                  {companyList?.length > 0 &&
                    companyList?.map((list, index) => {
                      const workIds =
                        typeof list?.workTypeIds === 'string'
                          ? list.workTypeIds.split(',')
                          : Array.isArray(list?.workTypeIds)
                          ? list.workTypeIds
                          : [];
                      // const workIds = list?.workTypeIds ? list?.workTypeIds?.split(",") : [];
                      const timeAgo = moment(list?.updated_At).fromNow(true);
                      const [count, unit] = timeAgo?.split(' ');
                      const formattedUnit = timeMapping[unit] || unit;
                      return (
                        <div key={index}>
                          <div
                            className={clsx(
                              'job-list-item',
                              jobDetailview?.jobPostId === list.jobPostId &&
                                'job-list-selected-item'
                            )}
                            onClick={() => setJobDetailview(list)}
                          >
                            {list?.companyLogo ? (
                              <img
                                alt="company-logo"
                                className="job-list-company-logo"
                                src={list?.companyLogo}
                              />
                            ) : (
                              <SampleCompany className="job-list-sample-company-logo" />
                            )}
                            <div className="job-list-short-preview">
                              <div className="job-title">{list?.jobTitle}</div>
                              <div className="job-companyname">
                                {list?.companyName}
                              </div>
                              <div className="job-list-types">
                                {list?.location?.map((item, index) => {
                                  const ctr = countryList.find(
                                    (ele) => ele.value === item.country
                                  )?.label;
                                  return (
                                    <span key={index}>
                                      {item?.city
                                        ? item?.city + ', ' + ctr + ' '
                                        : ctr + ' '}
                                    </span>
                                  );
                                })}
                              </div>
                              <div className="job-list-types">
                                {workIds?.map((itemId, index) => {
                                  return (
                                    <span key={index}>
                                      {
                                        workTypeList.find(
                                          (workTypeItem) =>
                                            workTypeItem.value == itemId
                                        )?.label
                                      }
                                      {workIds?.length !== index + 1 && ',  '}
                                    </span>
                                  );
                                })}
                              </div>
                              <div className="job-list-post-time">
                                {count} {formattedUnit}
                              </div>
                            </div>
                          </div>
                          <Divider />
                        </div>
                      );
                    })}
                  <div
                    className={clsx(
                      'pagination-container',
                      !isSmallScreen && 'mobile-pagination-style'
                    )}
                  >
                    <PaginationComp
                      size="medium"
                      totalPageSize={joblist?.hasMore ? page + 2 : page + 1}
                      page={page + 1}
                      isDisplayDot={joblist?.hasMore}
                      handleChange={(value) => {
                        if (isLoggedIn) {
                          setLoading(true);
                          setPage(value - 1);
                        } else {
                          setIsLoginNotificationOpen(true);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              {isSmallScreen ? (
                <>
                  <Divider orientation="vertical" flexItem />
                  <Preview state={jobDetailview} isApply={true} />
                </>
              ) : (
                <SwipeableEdgeDrawer
                  openDrawer={jobDetailview?.jobPostId}
                  handleCloseDrawer={() => setJobDetailview({})}
                >
                  <Preview state={jobDetailview} isApply={true} />
                </SwipeableEdgeDrawer>
              )}
            </JobPostList>
          ) : (
            !loading && (
              <div className="job-no-data-found">
                <NoDataFound />
                <div>{t('Job.FilterReset')}</div>
              </div>
            )
          )}
        </PostBox>
        <LoginNotification
          isLoginNotificationOpen={isLoginNotificationOpen}
          handleUpdateModal={() => setIsLoginNotificationOpen(false)}
        />
      </JobPostsStyle>
    </>
  );
}
